import { http } from 'services';

export const All = () => http.request.get('/v1/gov-function/reference/organizations');

export const List = ({ params }) => http.request.post('/v1/gov-function/open-organization/pageable', {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter
  });